import { Component, ElementRef, EventEmitter, inject, Input, NgZone, OnDestroy, AfterViewInit, Output, ViewChild } from '@angular/core';

declare const grecaptcha: {
  ready(cb: () => void): void;
  render(container: HTMLElement, params: { sitekey: string; callback: (token: string) => void; 'expired-callback': () => void }): number;
  reset(widgetId?: number): void;
};

@Component({
  standalone: true,
  selector: 'app-recaptcha',
  template: `<div #container></div>`,
})
export class RecaptchaComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) siteKey!: string;
  @ViewChild('container') private container!: ElementRef<HTMLElement>;

  @Output() readonly resolved = new EventEmitter<string | null>();

  private readonly ngZone = inject(NgZone);
  private widgetId: number | undefined;

  ngAfterViewInit(): void {
    grecaptcha.ready(() => {
      this.widgetId = grecaptcha.render(this.container.nativeElement, {
        sitekey: this.siteKey,
        callback: (token) => this.ngZone.run(() => this.resolved.emit(token)),
        'expired-callback': () => this.ngZone.run(() => this.resolved.emit(null)),
      });
    });
  }

  ngOnDestroy(): void {
    if (this.widgetId !== undefined) {
      grecaptcha.reset(this.widgetId);
    }
  }
}
